import $ from './el.JsModules.js';

const SELECTOR = {
  OVERLAY: '.js-overlay',
  CLOSE_BTN: '.js-close-button',
  TEMPLATE: '.js-location-template',
  CONTENT: '.js-content',
};

elabs.StockChecker = class {
  'use strict';

  constructor(element) {
    this.view = $(element);
    this.view.css('display', 'flex');
    this.content = this.view.find(SELECTOR.CONTENT);
    this.template = $(this.view.find(SELECTOR.TEMPLATE)[0].content);
    this.overlay = this.view.find(SELECTOR.OVERLAY);
    this.closeBtn = this.view.find(SELECTOR.CLOSE_BTN);

    this.overlay.on('click', () => {
      this.hide();
    });
    this.closeBtn.on('click', () => {
      this.hide();
    });
  }

  async init() {
    try {
      const locations = (await elabs.Utils.getStoreLocations()).filter(
        (location) => location?.should_show_in_stock_checker,
      );
      console.log({ locations });

      this.renderContent(locations);
    } catch (error) {
      console.error('Failed to load store locations:', error);
    }
  }

  renderContent(locations) {
    locations.forEach((location) => {
      const { id, name, address1, address2, city, zip, store_opening_hours, mobile_images } = location;
      const image = mobile_images[0];

      const template = this.template.clone();

      template.find('.js-image').attr({
        src: image?.src || '',
        alt: image?.alt || '',
        sizes: '500px',
        srcset: image?.srcset || '',
      });

      template.find('.js-location-name').text(name);
      template.find('.js-location-address').text(`${address1} ${address2}`);
      template.find('.js-city-zip').text(`${city} ${zip}`);
      template.find('.js-open-hours').append(store_opening_hours);
      template.find('.js-inventory').attr('data-location-id', id);

      this.content.append(template);
    });
  }

  show() {
    this.view.addClass('active');
    this.toggleBodyClasses();
  }

  hide() {
    this.view.removeClass('active');
    this.toggleBodyClasses();
  }

  toggleBodyClasses() {
    $('body').toggleClass('overflow-hidden blur-content');
  }
};

// Init
elabs.onJavascriptReady(async function () {
  const stockChecker = new elabs.StockChecker($('#StockChecker'));
  await stockChecker.init();
  window.stockChecker = stockChecker;
});
